import { defineTokens } from '@chakra-ui/react';

export const durations = defineTokens.durations({
  // Decorative column drift on account entry pages; independent of interface transitions.
  ambient: { value: '10s' },
  ambientSlow: { value: '15s' },
  /*
    Оборот спиннера. Не ступень перехода, а период цикла: стоковые 0.7s читаются как тревога,
    0.85s - как работа. Отдельное имя, чтобы скорость ожидания везде менялась одной строкой.
  */
  spinner: {
    value: '850ms',
  },
  fastest: {
    value: '50ms',
  },
  faster: {
    value: '100ms',
  },
  fast: {
    value: '150ms',
  },
  moderate: {
    value: '200ms',
  },
  slow: {
    value: '300ms',
  },
  slower: {
    value: '400ms',
  },
  slowest: {
    value: '500ms',
  },
});
